export const getAndroidWinnerAnswerFontSizePx = (answer) => {
  const len = String(answer || '').replace(/[“”]/g, '').length;
  if (len <= 22) return 27;
  if (len <= 34) return 24;
  if (len <= 48) return 21;
  if (len <= 64) return 18;
  return 16;
};
